import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Tabs from '../../../components/tabs';
import { getUser, getUsersInclusive } from '../../../reducers/users';
import { getJobs } from '../../../reducers/jobs';
import { getClientWorkers } from '../../../reducers/clients';
import GeneralTab from '../tabs/general';
import DocumentsTab from '../../../components/lists/workerDocuments';
import AssignmentTab from '../tabs/assignment';
import { getFullName } from '../../../utilities/string';
import { getJobProjects } from '../../../reducers/timekeeping';
import { getClientsProjects } from '../../../reducers/projects';
import { sendInvite } from '../../../reducers/invites';

class ClientWorker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.inviteUser = this.inviteUser.bind(this);
        this.loadWorkers = this.loadWorkers.bind(this);
    }

    componentDidMount() {
        const { clientId, getUsersInclusive, getClientsProjects, role } = this.props;
        getUsersInclusive(role, undefined, ['contractor']);
        getClientsProjects(clientId);
        this.loadWorkers();
    }

    loadWorkers() {
        const { clientId, getClientWorkers, getJobProjects, contractorId } = this.props;
        getClientWorkers(clientId, () => true, undefined, result => {
            let job = result ? result.find(w => w.contractor_id === contractorId) : undefined;
            getJobProjects(job.id);
        });
    }

    inviteUser(values, onFinish) {
        const { sendInvite, role, getUsersInclusive } = this.props;
        sendInvite({ ...values, clientId: role.id, ref_id: role.id, ref_type: 'client' }, role, () => {
            getUsersInclusive(
                role,
                result => {
                    onFinish(result.find(u => u.email === values.email));
                },
                ['contractor']
            );
        });
    }

    render() {
        const { admin, user, job, projects, projectsOptions, users } = this.props;
        if (!user || !job || !projects) return null;

        const tabs = [
            { title: <FormattedMessage {...messages.general} />, content: <GeneralTab roleType={'client'} job={job} user={user} /> },
            {
                title: <FormattedMessage {...messages.assignment} />,
                content: (
                    <AssignmentTab
                        roleType={'client'}
                        job={job}
                        user={user}
                        users={users}
                        projects={projects}
                        projectsOptions={projectsOptions}
                        inviteUser={this.inviteUser}
                        reload={this.loadWorkers}
                        admin={admin}
                    />
                )
            },
            { title: <FormattedMessage {...messages.documents} />, content: <DocumentsTab roleType={'client'} job={job} /> }
        ];

        return (
            <div className="row">
                <div className="col-xs-12">
                    <Tabs items={tabs} pageWide title={getFullName(user)} isPageTitle={true} />
                </div>
            </div>
        );
    }
}

ClientWorker.defaultProps = {
    clientId: undefined,
    contractorId: undefined,
    workerId: undefined
};
ClientWorker.propsTypes = {
    clientId: PropTypes.string.isRequired,
    contractorId: PropTypes.string.isRequired,
    workerId: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => {
    const { workerId, contractorId } = props;
    let user = state.users.list ? state.users.list.find(u => u.id === workerId) : undefined;
    let job = state.clients.workers ? state.clients.workers.find(w => w.contractor_id === contractorId) : undefined;
    const projects = state.projects.list;
    const projectsOptions = (projects || []).map(p => ({ value: p.id, label: p.name }));
    const admin = state.users.adminDetails;
    return {
        admin,
        user,
        users: state.users.list,
        projectsOptions,
        job,
        projects: state.timekeeping.projects,
        role: state.identity.role
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getUser,
            getJobs,
            getClientWorkers,
            getJobProjects,
            getClientsProjects,
            getUsersInclusive,
            sendInvite
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientWorker);



// WEBPACK FOOTER //
// ./src/pages/worker/tenants/client.jsx